import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import { createStore } from "./store/store";


import Toasted from 'vue-toasted';
import VueClipboard from 'vue-clipboard2'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(Toasted);
Vue.use(VueClipboard);
Vue.component('font-awesome-icon', FontAwesomeIcon);



import './bootstrap/font-awesome.js'
import './bootstrap/filters.js'
import './bootstrap/components.js'
import './bootstrap/unique-id.js'
import './bootstrap/numeral.js'
import './bootstrap/dayjs.js'
import './bootstrap/toasted.js'
import './bootstrap/flatpickr.js'
import './bootstrap/vue-modal.js'


import "./main.scss";

Vue.config.productionTip = false;

export default new Vue({
    router,
    store: createStore(),
    render: h => h(App)
}).$mount('#app');
